// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3yE7b","productName":"Table_productName__2TrDt"};